import { render } from "./studioRight.vue?vue&type=template&id=250031c6&scoped=true"
import script from "./studioRight.vue?vue&type=script&lang=js"
export * from "./studioRight.vue?vue&type=script&lang=js"

import "./studioRight.vue?vue&type=style&index=0&id=250031c6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250031c6"]])

export default __exports__